export enum DetectedSensitiveWordType {
    IvrSetting =1
}

export default DetectedSensitiveWordType